import { Navigate, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import BlogListPage from "./pages/blog/BlogListPage";
import BlogDetailPage from "./pages/blog/BlogDetailPage";
import BlogWritePage from "./pages/blog/BlogWritePage";
import LoginPage from "./pages/blog/LoginPage";
import ProjectsListPage from "./pages/projects/ProjectsListPage";
import ProjectDetailPage from "./pages/projects/ProjectDetailPage";
import ProjectWritePage from "./pages/projects/ProjectWritePage";
import "./App.css";

const AppLayout = () => (
  <>
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/projects" element={<ProjectsListPage />} />
      <Route path="/projects/write" element={<ProjectWritePage />} />
      <Route path="/projects/:id" element={<ProjectDetailPage />} />
      <Route path="/projects/:id/edit" element={<ProjectWritePage />} />
      <Route path="/blog" element={<BlogListPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/blog/write" element={<BlogWritePage />} />
      <Route path="/blog/:id" element={<BlogDetailPage />} />
      <Route path="/blog/:id/edit" element={<BlogWritePage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </>
);

function App() {
  return (
    <AuthProvider>
      <AppLayout />
    </AuthProvider>
  );
}

export default App;
